import { Helmet } from 'react-helmet-async';

import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SwipeableViews from 'react-swipeable-views';
// @mui
import { Stack, Paper, Button, Container, Typography, Tabs, Tab, Box } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import PropTypes from 'prop-types';
import { tabsClasses } from '@mui/material/Tabs';

import EditCandidate from 'src/components/Candidates/EditCandidate';
import CandidateDetails from 'src/components/Candidates/CandidateDetails';

import CandidateAttachmentsList from './CandidateAttachmentsList';
import ScheduleInterviews from 'src/components/Candidates/ScheduleInterviews';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
export default function CandidateTabsPage(props) {
  const navigate = useNavigate();

  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  const handleClose = () => {
    setOpen(false);
  };

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeIndex = (index) => {
    setValue(index);
  };
  return (
    <>
      <Helmet>
        <title> Candidates | Immigration System </title>
      </Helmet>
      <Container>
        {/* <Box
          p={4}
          component={Paper}
          boxShadow={3}
          sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
        > */}
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom></Typography>

          <Stack direction="row" spacing={2}>
            <Button
              onClick={() => {
                navigate(-1);
              }}
              variant="contained"
            >
              Back
            </Button>
          </Stack>
        </Stack>

        <Box component={Paper}>
          <Tabs
            value={value}
            onChange={handleChange}
            textColor="primary"
            indicatorColor="primary"
            aria-label="primary tabs example"
            variant="scrollable"
            scrollButtons
            sx={{
              [`& .${tabsClasses.scrollButtons}`]: {
                '&.Mui-disabled': { opacity: 0.3 },
              },
            }}
          >
            <Tab label="Edit" {...a11yProps(0)} />
            <Tab label="Details" {...a11yProps(1)} />
            {/* <Tab label="Education Info" {...a11yProps(2)} />
            <Tab label="Experience Info" {...a11yProps(3)} /> */}
            <Tab label="Documents" {...a11yProps(2)} />
            <Tab label="Schedule Interview" {...a11yProps(3)} />
          </Tabs>

          <SwipeableViews axis="x-reverse" index={value} onChangeIndex={handleChangeIndex}>
            <TabPanel value={value} index={0}>
              <EditCandidate setMessage={setMessage} setLoading={setLoading} setSaved={setSaved} setOpen={setOpen} />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <CandidateDetails setMessage={setMessage} setLoading={setLoading} setSaved={setSaved} setOpen={setOpen} />
            </TabPanel>

            <TabPanel value={value} index={2}>
              <CandidateAttachmentsList
                setMessage={setMessage}
                setLoading={setLoading}
                setSaved={setSaved}
                setOpen={setOpen}
              />
            </TabPanel>
            <TabPanel value={value} index={3}>
              <ScheduleInterviews
                setMessage={setMessage}
                setLoading={setLoading}
                setSaved={setSaved}
                setOpen={setOpen}
              />
            </TabPanel>
          </SwipeableViews>
        </Box>
        {/* </Box> */}
      </Container>
      {saved ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
            {message}
          </Alert>
        </Snackbar>
      ) : (
        <Snackbar
          key={vertical + horizontal}
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
            {message}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}
